const Promise = require('bluebird')
const Vue = require('vue')

const styler = require('./styler')
const components = require('./components')
const widgets = require('./widgets')
const ui = require('./ui')
const simpleCache = require('./simpleCache')

const { Templater, VueUtils } = require('microsistec')
const VueRouter = require('vue-router')
const VueValidator = require('./helpers/new-validator')
const utils = require('sci/utils')

const VueLazyload = require('vue-lazyload')

const dependencies = [
    simpleCache,
    widgets,
    components,
    styler,
    ui
]

Vue.use(VueRouter)
Vue.use(new Templater())
Vue.use(new VueUtils())
Vue.use(new VueValidator())
Vue.use(VueLazyload.default, {
    // preLoad: 1.3,
    // error: 'dist/error.png',
    loading: utils.asset('/img/cube-loading.apng'),
    attempt: 1
})

class System {
    /**
     * Faz o boot do frontend, configura e carrega todos os modulos de terceiros
     */
    static boot () {
        window.addEventListener('dragover', function (e) {
            e.preventDefault()
        }, false)
        window.addEventListener('drop', function (e) {
            e.preventDefault()
        }, false)

        Vue.config.debug = true

        require('./std/underworld')
        require('./std/service-worker')

        return Promise.each(dependencies, (dependency) => dependency()).then((values) => {
            return values
        })
    }
}

window.System = System

module.exports = System



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/system.js